import React, { useCallback, useEffect, useState } from 'react';
import api from '../../utils/axios';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { History, RefreshCw, AlertTriangle } from 'lucide-react';

const TIPOS = {
  EJECUCION_AUTO: { l: 'Ejecución automática', cls: 'bg-red-100 text-red-700' },
  EJECUCION_MANUAL: { l: 'Ejecución manual', cls: 'bg-indigo-100 text-indigo-700' },
  SIMULACION: { l: 'Simulación', cls: 'bg-slate-100 text-slate-600' },
  ERROR_MOTOR: { l: 'Error del motor', cls: 'bg-rose-600 text-white' },
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('es-AR', {
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'America/Argentina/Buenos_Aires',
}) : '—');

export const MotorLogCard = () => {
  const [log, setLog] = useState([]);
  const cargar = useCallback(() => {
    api.get('/waya-auto/log', { params: { limit: 30 } }).then((r) => setLog(r.data?.log || [])).catch(() => {});
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  return (
    <Card className="p-4 bg-white" data-testid="waya-auto-log">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold text-slate-800 flex items-center gap-1.5"><History size={15} /> Historial del motor</p>
        <Button size="sm" variant="ghost" onClick={cargar} className="h-7" data-testid="waya-auto-log-refresh"><RefreshCw size={13} /></Button>
      </div>
      {!log.length && <p className="text-xs text-slate-400" data-testid="waya-auto-log-vacio">Sin corridas registradas.</p>}
      <div className="max-h-72 overflow-y-auto divide-y divide-slate-100">
        {log.map((l) => {
          const t = TIPOS[l.tipo] || { l: l.tipo, cls: 'bg-slate-100 text-slate-600' };
          const r = l.resumen || {};
          return (
            <div key={l.id} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={`waya-auto-log-${l.id}`}>
              <span className="tabular-nums text-slate-500 w-24">{fmt(l.fecha)}</span>
              <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${t.cls}`}>{t.l}</span>
              {l.tipo === 'ERROR_MOTOR' ? (
                <span className="text-rose-700 flex items-center gap-1"><AlertTriangle size={12} /> {l.error}</span>
              ) : (
                <span className="text-slate-600">
                  {l.coincidencias ?? 0} coincidencia(s)
                  {r.bloqueos != null && <> · <b>{r.bloqueos}</b> bloqueo(s) · <b>{r.cierres}</b> cierre(s)</>}
                  {r.BLOQUEO != null && <> · aplicarían {r.BLOQUEO} bloqueo(s), {r.CIERRE} cierre(s), {r.excluidas || 0} excluida(s), {r.sin_match || 0} sin coincidencia</>}
                </span>
              )}
              <span className="ml-auto text-slate-400">{l.por}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default MotorLogCard;
